import { Period } from '@web/blocks/apprentice-salary-calculator-block/calculation/apprentice-salary-calculation';
import generatePdfBody from '@web/blocks/apprentice-salary-calculator-block/utils/generate-pdf-body';
import PDFFooter from '@web/blocks/apprentice-salary-calculator-block/utils/generate-pfd-footer';
type FormAnswers = {
	employmentType: string;
	education: string;
	endDate: string;
	isBasicEducation: string;
	isAdultApprentice: string;
};


export default async function generatePdf(formData: FormAnswers, result: Period[]) {
	const footer = PDFFooter();

	try {
		const htmlContent = generatePdfBody(formData, result);

		const response = await fetch('/api/generate-pdf', {
			method: 'POST',
			body: JSON.stringify({ htmlContent, footer }),
		});

		if (!response.ok) {
			throw new Error('PDF generation failed');
		}

		const pdfBlob = await response.blob();
		const url = window.URL.createObjectURL(pdfBlob);
		const a = document.createElement('a');
		a.href = url;
		a.download = 'laerlingeloen-beregning.pdf'; // Changed filename to match content
		document.body.appendChild(a);
		a.click();

		window.URL.revokeObjectURL(url);
		document.body.removeChild(a);
	} catch (error) {
		console.error('Error generating PDF:', error);
	}
}
